import { getPracticeAssessmentDocPath } from '../../collections/collections/assessments'
import { ASSESSMENTS, ASSESSMENTS_ADMIN, USER_INVITES, USERS } from '../../collections/names'
import { FileField, FileType, ListField } from '../../types/forms/fields'
import { UserGroup } from '../../types/shared/db'
import { createFileField } from '../../utils/fields'

// admin files are stored in the assessment's patient-files directory as an artifact of the legacy system
export const getAssessmentFilesDir = (assessmentId: string, access: UserGroup) => {
  switch (access) {
    case 'admin':
      return `assessments/${assessmentId}/admin-files`
    case 'practice':
      return `assessments/${assessmentId}/practice-files`
    case 'patient':
      return `assessments/${assessmentId}/shared-files`
    default:
      throw new Error(`Invalid access: ${access}`)
  }
}

export const getPatientFilesDir = (uid: string, isInvite: boolean, access: UserGroup) => {
  const prefix = isInvite ? USER_INVITES : USERS
  switch (access) {
    case 'admin':
      return `${prefix}/${uid}/admin-files`
    case 'practice':
      return `${prefix}/${uid}/practice-files`
    case 'patient':
      return `${prefix}/${uid}/shared-files`
    default:
      throw new Error(`Invalid access: ${access}`)
  }
}

export const userGroupToFileIdPrefix = (access: UserGroup) => {
  switch (access) {
    case 'admin':
      return 'adminFiles'
    case 'practice':
      return 'practiceFiles'
    case 'patient':
      return 'files'
    default:
      throw new Error(`Invalid access: ${access}`)
  }
}

export const getAssessmentFilesDocPath = (
  assessmentId: string,
  access: UserGroup,
  practiceId: string | undefined | null,
) => {
  switch (access) {
    case 'admin':
      return `${ASSESSMENTS_ADMIN}/${assessmentId}`
    case 'patient':
      return `${ASSESSMENTS}/${assessmentId}`
    case 'practice':
      if (!practiceId) return null
      return getPracticeAssessmentDocPath(practiceId, assessmentId)
    default:
      throw new Error(`Invalid access: ${access}`)
  }
}

export const getPatientFileField = (name: string, fileType?: FileType): FileField =>
  createFileField({
    name,
    placeholder: 'Patient File',
    fileType,
  })

export const getPatientFilesField = (name: string, fileType?: FileType): ListField => ({
  itemFields: getPatientFileField(name, fileType),
  name: 'Files',
  itemName: 'File',
})
